module.exports = __webpack_public_path__ + "img/c-review.98edff95.svg";